export const handbookRules = [
  'owasp:api1:2023-no-numeric-ids',
  'owasp:api2:2023-auth-insecure-schemes',
  'owasp:api2:2023-jwt-best-practices',
  'owasp:api2:2023-no-api-keys-in-url',
  'owasp:api2:2023-no-credentials-in-url',
  'owasp:api2:2023-no-http-basic',
  'owasp:api2:2023-short-lived-access-tokens',
  'owasp:api2:2023-write-restricted',
  'owasp:api4:2023-array-limit',
  'owasp:api4:2023-integer-format',
  'owasp:api4:2023-integer-limit',
  'owasp:api4:2023-integer-limit-legacy',
  'owasp:api4:2023-rate-limit',
  'owasp:api4:2023-rate-limit-retry-after',
  'owasp:api4:2023-string-limit',
  'owasp:api5:2023-admin-security-unique',
  'owasp:api8:2023-no-scheme-http',
  'owasp:api8:2023-no-server-http',
  'owasp:api9:2023-inventory-access',
  'owasp:api9:2023-inventory-environment',
  'valid-content-type',
  'valid-http-status-codes',
  'no-2xx-with-error',
  'uri-no-verbs',
  'uri-no-underscores',
  'uri-no-crud-names',
  'uri-no-numerical-values',
  'uri-path',
  'uri-no-trailing-slash',
  'uri-no-circular-reference',
  'query-parameters',
  'required-headers',
  'parser',
];
